const configuration = {
  apiBase: "/api/v1",
};

export default configuration;
